const level1_lis = document.querySelectorAll('.b-nav-level1__li')
const level2_lis = document.querySelectorAll('.b-nav-level2__item')
const menusWithSubMenu = document.querySelectorAll('.b-nav-item--has-submenu ');
const backButtons = document.querySelectorAll('.b-nav-submenu__back-btn');
const desktopCloseButtons = document.querySelectorAll('.b-nav-level2__desktop-close-button')


// fn to find li siblings
const findSiblings = (clickedElem) => {
  var siblings = [],
    node = clickedElem.parentNode.firstChild;

  while (node) {
    if (node !== clickedElem && node.nodeType === Node.ELEMENT_NODE)
      siblings.push(node);
    node = node.nextElementSibling || node.nextSibling;
  }
  return siblings
}



level1_lis.forEach(level1_li => {
  level1_li.addEventListener('click', function (e) {
    headerWrapper.classList.add('s-header-wrapper--fixed')
    fakeHeaderWrapper.classList.add('s-fake-header-wrapper--show')
    body.style.cssText = 'position: fixed; width: 100%; padding-top: 80px;'

    level2_lis.forEach(level2_li => {
      level2_li.classList.remove('b-nav-level2__item--active')
    });

  })
});

// for adding .active-li to current item
level1_lis.forEach(level1_li => {
  level1_li.addEventListener('mousedown', function () {

    // find siblings
    const siblings = findSiblings(this);

    // remove active class from siblings
    siblings.forEach(sibling => {
      sibling.querySelector('a').classList.remove('active-li')
    });
    // add active class to clicked element
    this.querySelector('a').classList.add('active-li')
  })
});





level2_lis.forEach(level2_li => {

  if (level2_li.classList.contains('b-nav-item--has-submenu')) {
    level2_li.addEventListener('click', function (e) {
      e.stopPropagation();
      // find siblings
      const siblings = findSiblings(this);

      // remove active class from siblings
      siblings.forEach(sibling => {
        if (sibling.classList.contains('b-nav-item--has-submenu')) {
          sibling.classList.remove('b-nav-level2__item--active')
        }
      });

      this.classList.add('b-nav-level2__item--active')
    })

  }

});


//show sub-menu
menusWithSubMenu.forEach(element => {
  element.addEventListener('click', function (e) {

    // find siblings
    const siblings = findSiblings(this);

    // remove active class from siblings
    siblings.forEach(sibling => {
      const sibSubMenu = sibling.querySelector('.b-nav-submenu')
      if (sibSubMenu) {

        sibSubMenu.classList.remove('b-nav-submenu--show')
        // sibSubMenu.classList.add('b-nav-submenu--hide')

        const otherSubMenus = sibling.querySelectorAll('.b-nav-submenu')
        otherSubMenus.forEach(element => {
          if (element.classList.contains('b-nav-submenu--show')) {
            element.classList.remove('b-nav-submenu--show');
            element.classList.add('b-nav-submenu--hide');
          }
        });
      }
    });

    // show the second level main navigation items if the device is larger than mobile,
    // as we only want to block this behaviour on mobile devices.
    if(window.innerWidth > 767){
      const theSubMenu = this.querySelector('.b-nav-submenu');
      theSubMenu.classList.remove('b-nav-submenu--hide');
      theSubMenu.classList.add('b-nav-submenu--show');
    }
    else{
      var target = element.querySelector('a').getAttribute('data-mobile-target');
      if(target != null){
        window.location = target;
      }
    }

  })
});

//hide sub-menu
if (backButtons) {
  backButtons.forEach(backButton => {
    backButton.addEventListener('click', function (e) {
      e.stopPropagation();
      this.parentElement.parentElement.classList.remove('b-nav-submenu--show');
      this.parentElement.parentElement.classList.add('b-nav-submenu--hide');
    })
  });
}


// desktop close button
if (desktopCloseButtons) {

  desktopCloseButtons.forEach(desktopCloseButton => {

    desktopCloseButton.addEventListener('click', function (e) {
      e.stopPropagation();

      level1_lis.forEach(li => {
        li.classList.remove('active')
        li.querySelector('a').classList.remove('active-li')
      });

      menusWithSubMenu.forEach(element => {

        if (element.classList.contains('b-nav-level1__li')) {
          const ul = element.querySelector('.b-nav-level2');
          ul.classList.remove('b-nav-submenu--show');
          ul.classList.add('b-nav-submenu--hide');
        }

        const otherSubMenus = element.querySelectorAll('.b-nav-submenu')
        otherSubMenus.forEach(element => {
          if (element.classList.contains('b-nav-submenu--show')) {
            element.classList.remove('b-nav-submenu--show');
            element.classList.add('b-nav-submenu--hide');
          }
        });

      });

      headerWrapper.classList.remove('s-header-wrapper--fixed')
      fakeHeaderWrapper.classList.remove('s-fake-header-wrapper--show')
      body.style.cssText = 'position: inital'
    })
  });

}
